import { Component } from '@angular/core';
import { ChatCardComponent } from '../common/chat-card/chat-card.component';

@Component({
  selector: 'app-analytics',
  imports: [ChatCardComponent],
  templateUrl: './analytics.component.html',
  styleUrl: './analytics.component.scss',
})
export class AnalyticsComponent {}
